export const projects = [
  {
    title: "EventetSot",
    category: "Event Platform",
    year: "2025",
    featured: true,
    tags: ["Full-Stack"],
    tech: ["React", "Tailwind", "Laravel", "MySQL"],
    description:
      "A modern event platform rebuilt with React and Tailwind on top of existing Laravel logic — ticketing, organiser tools and a user panel that finally feels fast.",
    image: "/projects/eventetsot.webp",
    link: null,
  },
  {
    title: "Beauty System",
    category: "Management Dashboard",
    year: "2025",
    featured: true,
    tags: ["Full-Stack", "Dashboards"],
    tech: ["Laravel", "React", "Tailwind", "MySQL"],
    description:
      "A salon management dashboard: appointments, client records and reporting wrapped in a calm, luxury interface.",
    image: "/projects/beauty-system.webp",
    link: null,
  },
  {
    title: "GrowCast",
    category: "AI Agriculture App",
    year: "2025",
    featured: false,
    tags: ["Full-Stack"],
    tech: ["React", "Laravel", "AI"],
    description:
      "Weather data and AI predictions combined to help farmers decide when to plant, water and harvest.",
    image: "/projects/growcast.webp",
    link: null,
  },
  {
    title: "Traquiva",
    category: "Platform Experience",
    year: "2025",
    tags: ["Dashboards"],
    tech: ["Community", "Admin", "Product"],
    description:
      "Beta testing, dashboard feedback and community experience work on a live product platform.",
    image: "/projects/traquiva.webp",
    link: "https://traquiva.com/",
  },
  {
    title: "Glowly",
    category: "E-commerce UI",
    year: "2024",
    tags: ["Front-End"],
    tech: ["React", "Tailwind"],
    description:
      "A skincare storefront with an elegant browsing and shopping experience.",
    image: "/projects/glowly.webp",
    link: "https://glowinga.netlify.app/",
  },
  {
    title: "Coffee Shop",
    category: "Ordering Website",
    year: "2024",
    tags: ["Front-End"],
    tech: ["React", "Tailwind"],
    description:
      "A coffee ordering site built around a warm, responsive interface.",
    image: "/projects/coffee-shop.webp",
    link: "https://startling-entremet-906389.netlify.app/",
  },
  {
    title: "FFlower Atelier",
    category: "Brand Website",
    year: "2024",
    tags: ["Front-End"],
    tech: ["HTML", "CSS", "JavaScript"],
    description:
      "An editorial website for a flower atelier, built around its bouquet showcase.",
    image: "/projects/fflower-atelier.webp",
    link: "https://albinademaj.github.io/fflower-atlier/",
  },
  {
    title: "Restaurant",
    category: "Restaurant Website",
    year: "2024",
    tags: ["Front-End"],
    tech: ["HTML", "Tailwind"],
    description:
      "A restaurant site with modern responsive sections and a clean menu layout.",
    image: "/projects/restaurant.webp",
    link: "https://albinademaj.github.io/RESTAUR/",
  },
  {
    title: "TastyBite",
    category: "Recipe Website",
    year: "2023",
    tags: ["Front-End"],
    tech: ["Bootstrap", "JavaScript"],
    description:
      "A recipe library with categorised meals and quick, simple browsing.",
    image: "/projects/tastybite.webp",
    link: "https://albinademaj.github.io/TastyBite/",
  },
  {
    title: "RioRelax",
    category: "Hotel Website",
    year: "2023",
    tags: ["Front-End"],
    tech: ["HTML", "CSS"],
    description:
      "A hospitality website showcasing rooms, services and booking information.",
    image: "/projects/riorelax.webp",
    link: "https://albinademaj.github.io/RioRelax/",
  },
  {
    title: "Mixtas",
    category: "E-commerce Website",
    year: "2023",
    tags: ["Front-End"],
    tech: ["HTML", "CSS", "JavaScript"],
    description:
      "An e-commerce layout with product listings and a fully responsive grid.",
    image: "/projects/mixtas.webp",
    link: "https://albinademaj.github.io/Mixtas/",
  },
  {
    title: "Petalio",
    category: "Flower Shop",
    year: "2023",
    tags: ["Front-End"],
    tech: ["HTML", "CSS"],
    description:
      "An elegant flower shop concept with premium, editorial sections.",
    image: "/projects/petalio.webp",
    link: null,
  },
  {
    title: "Pet Shop",
    category: "Pet Website",
    year: "2023",
    tags: ["Front-End"],
    tech: ["HTML", "CSS"],
    description:
      "A pet adoption and shop website designed for easy, friendly browsing.",
    image: "/projects/petshop.webp",
    link: null,
  },
  {
    title: "Garage",
    category: "Service Website",
    year: "2023",
    tags: ["Front-End"],
    tech: ["HTML", "CSS"],
    description:
      "An automotive service website with a bold, modern layout.",
    image: "/projects/garage.webp",
    link: null,
  },
];

export const projectFilters = ["All", "Full-Stack", "Dashboards", "Front-End"];
